import { DefaultQueryParams } from '@frontend/api-utils';
import { ChartClient } from '@frontend/chart/api';
import { LendingReturnPackageVolumeHourDayHeatmapChart } from '@frontend/chart/components';
import { Chart } from '@frontend/chart/types';
import { useEffect, useState } from 'react';

import { getLast2WeeksHourDayChartRange } from '../../../statistics/pudo/last-30-days-chart-range';
import { hourDayHeatmapWindow } from '../insight-detail/insight-heatmap-window';
import { useInsightFetchRange } from '../insight-detail/use-insight-fetch-range';

export const useLendingReturnPackageVolumeHourDayHeatmapChart = (accountId: string) => {
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [rangeStart, setRangeStart] = useState<string | undefined>(undefined);
    const [dayCount, setDayCount] = useState<number | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    const fetchRange = useInsightFetchRange(getLast2WeeksHourDayChartRange);

    useEffect(() => {
        if (!accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        const { after, before } = fetchRange;
        const heatmapWindow = hourDayHeatmapWindow(after, before);
        setRangeStart(heatmapWindow.rangeStart);
        setDayCount(heatmapWindow.dayCount);

        ChartClient.fetchChartData(accountId, LendingReturnPackageVolumeHourDayHeatmapChart.definition, {
            [DefaultQueryParams.AFTER]: after,
            [DefaultQueryParams.BEFORE]: before,
            ...fetchRange.entityParams
        })
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [accountId, fetchRange.key]);

    return {
        data,
        isLoading,
        rangeStart,
        dayCount
    };
};
